import { isEmpty } from 'underscore';
// @ts-expect-error not typed
import makeSaveActions from 'ContentEditorUI/js/redux/actions/makeSaveActions';
// @ts-expect-error not typed
import bus from 'ContentEditorUI/coffee/lib/eventBus';
// @ts-expect-error not typed
import makeWaitForPendingInpageUpdates from 'ContentEditorUI/utils/makeWaitForPendingInpageUpdates';
// @ts-expect-error not typed
import { clearSaveAlerts } from 'ContentEditorUI/utils/errorUtils';
// @ts-expect-error not typed
import { validationFinished } from 'ContentEditorUI/redux/actions/appActions';
import { selectActiveHubDbRowId } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { getSaveData } from '../selectors/saveSelectors';
import { BASE_URL } from '../../articles/api/articlesApi';
import { selectArticleTitle } from '../selectors/editorSelectors';
function formatApiUrl(state) {
  const currentArticleId = selectActiveHubDbRowId(state);
  return `${BASE_URL}/${currentArticleId}/draft`;
}
function getIsSaveEnabled(state) {
  const articleTitle = selectArticleTitle(state);
  return articleTitle !== '';
}
const actions = makeSaveActions({
  apiUrl: formatApiUrl,
  isStructuredContent: true,
  serialize: getSaveData,
  wait: makeWaitForPendingInpageUpdates(bus),
  getIsSaveEnabled
});
export const save = opts => {
  clearSaveAlerts();
  return actions.save(opts);
};
export const autoSave = actions.autoSave;
export const autoSaveDebounced = actions.autoSaveDebounced;
export const validate = () => dispatch => {
  const errors = {};
  const valid = isEmpty(errors);
  return dispatch(validationFinished({
    valid,
    errors
  }));
};
export const autoSaveAndForcePageRefresh = () => dispatch => dispatch(autoSave()).then(() => {
  window.location.reload();
});